
export const matchData = [
    {
        "city": "Karachi",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Hyderabad City",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Quetta",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Sukkur",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Larkana",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Surab",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Sanghar",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Thari Mir Wah",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Shah Latif Town",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Khipro",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Mirpur Mathelo",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Nawabshah",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Kotri",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Mehrabpur",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Mirpur Khas",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Ratodero",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Thatta",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Turbat",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Mirpur Bhtoro",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Jacobabad",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Kuchlagh",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Talhar",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Hala",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Ziarat",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Dadu",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Khairpur Mir’s",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Khuzdar",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Tando Allahyar",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Sarhari",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Badin",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Goth Tando Sumro",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Ghotki",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Chaman",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Kandhkot",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Tando Muhammad Khan",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Shahdadpur",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Kambar",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Harnai",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Gwadar",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Dera Allahyar",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Panjgur",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Kathri",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Jamshoro",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Usta Muhammad",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Kahan",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Rohri",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Sakrand",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Zhob",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Kharan",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Bandhi",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Ranipur",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Naushahro Firoz",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Pishin",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Umarkot",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Pasni",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Uthal",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Johi",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Qazi Ahmad",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Kalat",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Bela",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Mithi",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Mian Sahib",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Miro Khan",
        "country": "Pakistan",
        "admin_name": "Sindh",
        "Region": "South"
    },
    {
        "city": "Gadani",
        "country": "Pakistan",
        "admin_name": "Balochistan",
        "Region": "South"
    },
    {
        "city": "Lahore",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kotla Qasim Khan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Faisalabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Rawalpindi",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Gujranwala",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Peshawar",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Multan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "South"
    },
    {
        "city": "Islamabad",
        "country": "Pakistan",
        "admin_name": "Islamabad",
        "Region": "North"
    },
    {
        "city": "Bahawalpur",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Sargodha",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chak Forty-one",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Sialkot City",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Pindi Bhattian",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chiniot",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Shekhupura",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Rahimyar Khan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Jhang City",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Mardan",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Dera Ghazi Khan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Gujrat",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Cantonment",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Bhawana",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Malakwal",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Sarai Alamgir",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chak Jhumra",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kot Radha Kishan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kasur",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Khairpur Tamewah",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chakwal",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Mingaora",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Khwazakhela",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Sahiwal",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Hafizabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Okara",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Khanewal",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chilas",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Mandi Burewala",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Parachinar",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Jhelum",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Saddiqabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Khapalu",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Kohat",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Muridke",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Muzaffargarh",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Khanpur",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Gojra",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Mandi Bahauddin",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Eminabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Jaranwala",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chauk Azam",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Abbottabad",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Bahawalnagar",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Pakpattan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Zafarwal",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Ahmadpur East",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Wazirabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Vihari",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "New Mirpur",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Kamalia",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Renala Khurd",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kot Addu",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Nowshera",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Lodhran",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Swabi",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Khushab",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Dera Ismail Khan",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Bagu Na Mohra",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Charsadda",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Bahrain",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Chishtian",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Hasilpur",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Attock Khurd",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Muzaffarabad",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Arifwala",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Mianwali",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Shabqadar",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Jauharabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Nasatta",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Gujar Khan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Jalalpur Jattan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Bhakkar",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Dipalpur",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kharian",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Taxila",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Wadala Sandhuan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Mian Channun",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Bhalwal",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Khewra",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Dinga",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Pattoki",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Harunabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kahror Pakka",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Toba Tek Singh",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Samundri",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Shakargarh",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Sambrial",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Shujaabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Hujra Shah Muqim",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kabirwala",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Talamba",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Mansehra",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Lala Musa",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Saidu Sharif",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Chunian",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Nankana Sahib",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Bannu",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Faruka",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Pasrur",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Timargara",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Dina",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Rangewala",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chenab Nagar",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Hadali",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Liaquatpur",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Abdul Hakim",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kot Mumin",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Hassan Abdal",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chak Thirty-six North Branch",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Rukan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Buni",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Chak Sixty-one Gugera Branch",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Haripur",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Badrashni",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Lalian",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Tank",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Sukheke Mandi",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Jalalpur Bhattian",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Safdarabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Jalalabad",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Choa Saidan Shah",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Hangu",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Charbagh",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Kalu Khan",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Bat Khela",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Sillanwali",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Allahabad",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Risalpur Cantonment",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Karak",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Nawan Shahr",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Kundian",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chakdarra",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Sadda",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Landi Kotal",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Bagh",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Ghuenke",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Chitral",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Chak Five Hundred Seventy-five",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Masho Khel",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Dulmial",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Malak Abad",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Pind Dadan Khan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Hajira",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Ayun",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Bhimbar",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Atharan Hazari",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Batgram",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Arandu",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Jaglot",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Wahga",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Skardu",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Thal",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Dainyor",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Kulachi",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Idak",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Phularwan",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Uch Sharif",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Kotli",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Doaba",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Phalia",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Murree",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Akora",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Gahi Mammar",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Roulia",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Haji Shah",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Baltit",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Dhanot",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Awan Patti",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Sangota",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Ghora Gali",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Mankera",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Shergarh",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Sultanpur Mor",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Nurkot",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Saidpur",
        "country": "Pakistan",
        "admin_name": "Islamabad",
        "Region": "North"
    },
    {
        "city": "Hattian Bala",
        "country": "Pakistan",
        "admin_name": "Azad Kashmir",
        "Region": "North"
    },
    {
        "city": "Firoza",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Gakuch",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Haider Khel",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Surmon Chogga Grong",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Basla",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Bunji",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Ghota Fatehgarh",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    },
    {
        "city": "Jandola",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Gilgit",
        "country": "Pakistan",
        "admin_name": "Gilgit-Baltistan",
        "Region": "North"
    },
    {
        "city": "Drazinda",
        "country": "Pakistan",
        "admin_name": "Khyber Pakhtunkhwa",
        "Region": "North"
    },
    {
        "city": "Chak Thathi",
        "country": "Pakistan",
        "admin_name": "Punjab",
        "Region": "North"
    }
]

export const cityData = [
    {
        "label": "Karachi",
        "value": "Karachi"
    },
    {
        "label": "Hyderabad City",
        "value": "Hyderabad City"
    },
    {
        "label": "Quetta",
        "value": "Quetta"
    },
    {
        "label": "Sukkur",
        "value": "Sukkur"
    },
    {
        "label": "Larkana",
        "value": "Larkana"
    },
    {
        "label": "Surab",
        "value": "Surab"
    },
    {
        "label": "Sanghar",
        "value": "Sanghar"
    },
    {
        "label": "Thari Mir Wah",
        "value": "Thari Mir Wah"
    },
    {
        "label": "Shah Latif Town",
        "value": "Shah Latif Town"
    },
    {
        "label": "Khipro",
        "value": "Khipro"
    },
    {
        "label": "Mirpur Mathelo",
        "value": "Mirpur Mathelo"
    },
    {
        "label": "Nawabshah",
        "value": "Nawabshah"
    },
    {
        "label": "Kotri",
        "value": "Kotri"
    },
    {
        "label": "Mehrabpur",
        "value": "Mehrabpur"
    },
    {
        "label": "Mirpur Khas",
        "value": "Mirpur Khas"
    },
    {
        "label": "Ratodero",
        "value": "Ratodero"
    },
    {
        "label": "Thatta",
        "value": "Thatta"
    },
    {
        "label": "Turbat",
        "value": "Turbat"
    },
    {
        "label": "Mirpur Bhtoro",
        "value": "Mirpur Bhtoro"
    },
    {
        "label": "Jacobabad",
        "value": "Jacobabad"
    },
    {
        "label": "Kuchlagh",
        "value": "Kuchlagh"
    },
    {
        "label": "Talhar",
        "value": "Talhar"
    },
    {
        "label": "Hala",
        "value": "Hala"
    },
    {
        "label": "Ziarat",
        "value": "Ziarat"
    },
    {
        "label": "Dadu",
        "value": "Dadu"
    },
    {
        "label": "Khairpur Mir’s",
        "value": "Khairpur Mir’s"
    },
    {
        "label": "Khuzdar",
        "value": "Khuzdar"
    },
    {
        "label": "Tando Allahyar",
        "value": "Tando Allahyar"
    },
    {
        "label": "Sarhari",
        "value": "Sarhari"
    },
    {
        "label": "Badin",
        "value": "Badin"
    },
    {
        "label": "Goth Tando Sumro",
        "value": "Goth Tando Sumro"
    },
    {
        "label": "Ghotki",
        "value": "Ghotki"
    },
    {
        "label": "Chaman",
        "value": "Chaman"
    },
    {
        "label": "Kandhkot",
        "value": "Kandhkot"
    },
    {
        "label": "Tando Muhammad Khan",
        "value": "Tando Muhammad Khan"
    },
    {
        "label": "Shahdadpur",
        "value": "Shahdadpur"
    },
    {
        "label": "Kambar",
        "value": "Kambar"
    },
    {
        "label": "Harnai",
        "value": "Harnai"
    },
    {
        "label": "Gwadar",
        "value": "Gwadar"
    },
    {
        "label": "Dera Allahyar",
        "value": "Dera Allahyar"
    },
    {
        "label": "Panjgur",
        "value": "Panjgur"
    },
    {
        "label": "Kathri",
        "value": "Kathri"
    },
    {
        "label": "Jamshoro",
        "value": "Jamshoro"
    },
    {
        "label": "Usta Muhammad",
        "value": "Usta Muhammad"
    },
    {
        "label": "Kahan",
        "value": "Kahan"
    },
    {
        "label": "Rohri",
        "value": "Rohri"
    },
    {
        "label": "Sakrand",
        "value": "Sakrand"
    },
    {
        "label": "Zhob",
        "value": "Zhob"
    },
    {
        "label": "Kharan",
        "value": "Kharan"
    },
    {
        "label": "Bandhi",
        "value": "Bandhi"
    },
    {
        "label": "Ranipur",
        "value": "Ranipur"
    },
    {
        "label": "Naushahro Firoz",
        "value": "Naushahro Firoz"
    },
    {
        "label": "Pishin",
        "value": "Pishin"
    },
    {
        "label": "Umarkot",
        "value": "Umarkot"
    },
    {
        "label": "Pasni",
        "value": "Pasni"
    },
    {
        "label": "Uthal",
        "value": "Uthal"
    },
    {
        "label": "Johi",
        "value": "Johi"
    },
    {
        "label": "Qazi Ahmad",
        "value": "Qazi Ahmad"
    },
    {
        "label": "Kalat",
        "value": "Kalat"
    },
    {
        "label": "Bela",
        "value": "Bela"
    },
    {
        "label": "Mithi",
        "value": "Mithi"
    },
    {
        "label": "Mian Sahib",
        "value": "Mian Sahib"
    },
    {
        "label": "Miro Khan",
        "value": "Miro Khan"
    },
    {
        "label": "Gadani",
        "value": "Gadani"
    },
    {
        "label": "Lahore",
        "value": "Lahore"
    },
    {
        "label": "Kotla Qasim Khan",
        "value": "Kotla Qasim Khan"
    },
    {
        "label": "Faisalabad",
        "value": "Faisalabad"
    },
    {
        "label": "Rawalpindi",
        "value": "Rawalpindi"
    },
    {
        "label": "Gujranwala",
        "value": "Gujranwala"
    },
    {
        "label": "Peshawar",
        "value": "Peshawar"
    },
    {
        "label": "Multan",
        "value": "Multan"
    },
    {
        "label": "Islamabad",
        "value": "Islamabad"
    },
    {
        "label": "Bahawalpur",
        "value": "Bahawalpur"
    },
    {
        "label": "Sargodha",
        "value": "Sargodha"
    },
    {
        "label": "Chak Forty-one",
        "value": "Chak Forty-one"
    },
    {
        "label": "Sialkot City",
        "value": "Sialkot City"
    },
    {
        "label": "Pindi Bhattian",
        "value": "Pindi Bhattian"
    },
    {
        "label": "Chiniot",
        "value": "Chiniot"
    },
    {
        "label": "Shekhupura",
        "value": "Shekhupura"
    },
    {
        "label": "Rahimyar Khan",
        "value": "Rahimyar Khan"
    },
    {
        "label": "Jhang City",
        "value": "Jhang City"
    },
    {
        "label": "Mardan",
        "value": "Mardan"
    },
    {
        "label": "Dera Ghazi Khan",
        "value": "Dera Ghazi Khan"
    },
    {
        "label": "Gujrat",
        "value": "Gujrat"
    },
    {
        "label": "Cantonment",
        "value": "Cantonment"
    },
    {
        "label": "Bhawana",
        "value": "Bhawana"
    },
    {
        "label": "Malakwal",
        "value": "Malakwal"
    },
    {
        "label": "Sarai Alamgir",
        "value": "Sarai Alamgir"
    },
    {
        "label": "Chak Jhumra",
        "value": "Chak Jhumra"
    },
    {
        "label": "Kot Radha Kishan",
        "value": "Kot Radha Kishan"
    },
    {
        "label": "Kasur",
        "value": "Kasur"
    },
    {
        "label": "Khairpur Tamewah",
        "value": "Khairpur Tamewah"
    },
    {
        "label": "Chakwal",
        "value": "Chakwal"
    },
    {
        "label": "Mingaora",
        "value": "Mingaora"
    },
    {
        "label": "Khwazakhela",
        "value": "Khwazakhela"
    },
    {
        "label": "Sahiwal",
        "value": "Sahiwal"
    },
    {
        "label": "Hafizabad",
        "value": "Hafizabad"
    },
    {
        "label": "Okara",
        "value": "Okara"
    },
    {
        "label": "Khanewal",
        "value": "Khanewal"
    },
    {
        "label": "Chilas",
        "value": "Chilas"
    },
    {
        "label": "Mandi Burewala",
        "value": "Mandi Burewala"
    },
    {
        "label": "Parachinar",
        "value": "Parachinar"
    },
    {
        "label": "Jhelum",
        "value": "Jhelum"
    },
    {
        "label": "Saddiqabad",
        "value": "Saddiqabad"
    },
    {
        "label": "Khapalu",
        "value": "Khapalu"
    },
    {
        "label": "Kohat",
        "value": "Kohat"
    },
    {
        "label": "Muridke",
        "value": "Muridke"
    },
    {
        "label": "Muzaffargarh",
        "value": "Muzaffargarh"
    },
    {
        "label": "Khanpur",
        "value": "Khanpur"
    },
    {
        "label": "Gojra",
        "value": "Gojra"
    },
    {
        "label": "Mandi Bahauddin",
        "value": "Mandi Bahauddin"
    },
    {
        "label": "Eminabad",
        "value": "Eminabad"
    },
    {
        "label": "Jaranwala",
        "value": "Jaranwala"
    },
    {
        "label": "Chauk Azam",
        "value": "Chauk Azam"
    },
    {
        "label": "Abbottabad",
        "value": "Abbottabad"
    },
    {
        "label": "Bahawalnagar",
        "value": "Bahawalnagar"
    },
    {
        "label": "Pakpattan",
        "value": "Pakpattan"
    },
    {
        "label": "Zafarwal",
        "value": "Zafarwal"
    },
    {
        "label": "Ahmadpur East",
        "value": "Ahmadpur East"
    },
    {
        "label": "Wazirabad",
        "value": "Wazirabad"
    },
    {
        "label": "Vihari",
        "value": "Vihari"
    },
    {
        "label": "New Mirpur",
        "value": "New Mirpur"
    },
    {
        "label": "Kamalia",
        "value": "Kamalia"
    },
    {
        "label": "Renala Khurd",
        "value": "Renala Khurd"
    },
    {
        "label": "Kot Addu",
        "value": "Kot Addu"
    },
    {
        "label": "Nowshera",
        "value": "Nowshera"
    },
    {
        "label": "Lodhran",
        "value": "Lodhran"
    },
    {
        "label": "Swabi",
        "value": "Swabi"
    },
    {
        "label": "Khushab",
        "value": "Khushab"
    },
    {
        "label": "Dera Ismail Khan",
        "value": "Dera Ismail Khan"
    },
    {
        "label": "Bagu Na Mohra",
        "value": "Bagu Na Mohra"
    },
    {
        "label": "Charsadda",
        "value": "Charsadda"
    },
    {
        "label": "Bahrain",
        "value": "Bahrain"
    },
    {
        "label": "Chishtian",
        "value": "Chishtian"
    },
    {
        "label": "Hasilpur",
        "value": "Hasilpur"
    },
    {
        "label": "Attock Khurd",
        "value": "Attock Khurd"
    },
    {
        "label": "Muzaffarabad",
        "value": "Muzaffarabad"
    },
    {
        "label": "Arifwala",
        "value": "Arifwala"
    },
    {
        "label": "Mianwali",
        "value": "Mianwali"
    },
    {
        "label": "Shabqadar",
        "value": "Shabqadar"
    },
    {
        "label": "Jauharabad",
        "value": "Jauharabad"
    },
    {
        "label": "Nasatta",
        "value": "Nasatta"
    },
    {
        "label": "Gujar Khan",
        "value": "Gujar Khan"
    },
    {
        "label": "Jalalpur Jattan",
        "value": "Jalalpur Jattan"
    },
    {
        "label": "Bhakkar",
        "value": "Bhakkar"
    },
    {
        "label": "Dipalpur",
        "value": "Dipalpur"
    },
    {
        "label": "Kharian",
        "value": "Kharian"
    },
    {
        "label": "Taxila",
        "value": "Taxila"
    },
    {
        "label": "Wadala Sandhuan",
        "value": "Wadala Sandhuan"
    },
    {
        "label": "Mian Channun",
        "value": "Mian Channun"
    },
    {
        "label": "Bhalwal",
        "value": "Bhalwal"
    },
    {
        "label": "Khewra",
        "value": "Khewra"
    },
    {
        "label": "Dinga",
        "value": "Dinga"
    },
    {
        "label": "Pattoki",
        "value": "Pattoki"
    },
    {
        "label": "Harunabad",
        "value": "Harunabad"
    },
    {
        "label": "Kahror Pakka",
        "value": "Kahror Pakka"
    },
    {
        "label": "Toba Tek Singh",
        "value": "Toba Tek Singh"
    },
    {
        "label": "Samundri",
        "value": "Samundri"
    },
    {
        "label": "Shakargarh",
        "value": "Shakargarh"
    },
    {
        "label": "Sambrial",
        "value": "Sambrial"
    },
    {
        "label": "Shujaabad",
        "value": "Shujaabad"
    },
    {
        "label": "Hujra Shah Muqim",
        "value": "Hujra Shah Muqim"
    },
    {
        "label": "Kabirwala",
        "value": "Kabirwala"
    },
    {
        "label": "Talamba",
        "value": "Talamba"
    },
    {
        "label": "Mansehra",
        "value": "Mansehra"
    },
    {
        "label": "Lala Musa",
        "value": "Lala Musa"
    },
    {
        "label": "Saidu Sharif",
        "value": "Saidu Sharif"
    },
    {
        "label": "Chunian",
        "value": "Chunian"
    },
    {
        "label": "Nankana Sahib",
        "value": "Nankana Sahib"
    },
    {
        "label": "Bannu",
        "value": "Bannu"
    },
    {
        "label": "Faruka",
        "value": "Faruka"
    },
    {
        "label": "Pasrur",
        "value": "Pasrur"
    },
    {
        "label": "Timargara",
        "value": "Timargara"
    },
    {
        "label": "Dina",
        "value": "Dina"
    },
    {
        "label": "Rangewala",
        "value": "Rangewala"
    },
    {
        "label": "Chenab Nagar",
        "value": "Chenab Nagar"
    },
    {
        "label": "Hadali",
        "value": "Hadali"
    },
    {
        "label": "Liaquatpur",
        "value": "Liaquatpur"
    },
    {
        "label": "Abdul Hakim",
        "value": "Abdul Hakim"
    },
    {
        "label": "Kot Mumin",
        "value": "Kot Mumin"
    },
    {
        "label": "Hassan Abdal",
        "value": "Hassan Abdal"
    },
    {
        "label": "Chak Thirty-six North Branch",
        "value": "Chak Thirty-six North Branch"
    },
    {
        "label": "Rukan",
        "value": "Rukan"
    },
    {
        "label": "Buni",
        "value": "Buni"
    },
    {
        "label": "Chak Sixty-one Gugera Branch",
        "value": "Chak Sixty-one Gugera Branch"
    },
    {
        "label": "Haripur",
        "value": "Haripur"
    },
    {
        "label": "Badrashni",
        "value": "Badrashni"
    },
    {
        "label": "Lalian",
        "value": "Lalian"
    },
    {
        "label": "Tank",
        "value": "Tank"
    },
    {
        "label": "Sukheke Mandi",
        "value": "Sukheke Mandi"
    },
    {
        "label": "Jalalpur Bhattian",
        "value": "Jalalpur Bhattian"
    },
    {
        "label": "Safdarabad",
        "value": "Safdarabad"
    },
    {
        "label": "Jalalabad",
        "value": "Jalalabad"
    },
    {
        "label": "Choa Saidan Shah",
        "value": "Choa Saidan Shah"
    },
    {
        "label": "Hangu",
        "value": "Hangu"
    },
    {
        "label": "Charbagh",
        "value": "Charbagh"
    },
    {
        "label": "Kalu Khan",
        "value": "Kalu Khan"
    },
    {
        "label": "Bat Khela",
        "value": "Bat Khela"
    },
    {
        "label": "Sillanwali",
        "value": "Sillanwali"
    },
    {
        "label": "Allahabad",
        "value": "Allahabad"
    },
    {
        "label": "Risalpur Cantonment",
        "value": "Risalpur Cantonment"
    },
    {
        "label": "Karak",
        "value": "Karak"
    },
    {
        "label": "Nawan Shahr",
        "value": "Nawan Shahr"
    },
    {
        "label": "Kundian",
        "value": "Kundian"
    },
    {
        "label": "Chakdarra",
        "value": "Chakdarra"
    },
    {
        "label": "Sadda",
        "value": "Sadda"
    },
    {
        "label": "Landi Kotal",
        "value": "Landi Kotal"
    },
    {
        "label": "Bagh",
        "value": "Bagh"
    },
    {
        "label": "Ghuenke",
        "value": "Ghuenke"
    },
    {
        "label": "Chitral",
        "value": "Chitral"
    },
    {
        "label": "Chak Five Hundred Seventy-five",
        "value": "Chak Five Hundred Seventy-five"
    },
    {
        "label": "Masho Khel",
        "value": "Masho Khel"
    },
    {
        "label": "Dulmial",
        "value": "Dulmial"
    },
    {
        "label": "Malak Abad",
        "value": "Malak Abad"
    },
    {
        "label": "Pind Dadan Khan",
        "value": "Pind Dadan Khan"
    },
    {
        "label": "Hajira",
        "value": "Hajira"
    },
    {
        "label": "Ayun",
        "value": "Ayun"
    },
    {
        "label": "Bhimbar",
        "value": "Bhimbar"
    },
    {
        "label": "Atharan Hazari",
        "value": "Atharan Hazari"
    },
    {
        "label": "Batgram",
        "value": "Batgram"
    },
    {
        "label": "Arandu",
        "value": "Arandu"
    },
    {
        "label": "Jaglot",
        "value": "Jaglot"
    },
    {
        "label": "Wahga",
        "value": "Wahga"
    },
    {
        "label": "Skardu",
        "value": "Skardu"
    },
    {
        "label": "Thal",
        "value": "Thal"
    },
    {
        "label": "Dainyor",
        "value": "Dainyor"
    },
    {
        "label": "Kulachi",
        "value": "Kulachi"
    },
    {
        "label": "Idak",
        "value": "Idak"
    },
    {
        "label": "Phularwan",
        "value": "Phularwan"
    },
    {
        "label": "Uch Sharif",
        "value": "Uch Sharif"
    },
    {
        "label": "Kotli",
        "value": "Kotli"
    },
    {
        "label": "Doaba",
        "value": "Doaba"
    },
    {
        "label": "Phalia",
        "value": "Phalia"
    },
    {
        "label": "Murree",
        "value": "Murree"
    },
    {
        "label": "Akora",
        "value": "Akora"
    },
    {
        "label": "Gahi Mammar",
        "value": "Gahi Mammar"
    },
    {
        "label": "Roulia",
        "value": "Roulia"
    },
    {
        "label": "Haji Shah",
        "value": "Haji Shah"
    },
    {
        "label": "Baltit",
        "value": "Baltit"
    },
    {
        "label": "Dhanot",
        "value": "Dhanot"
    },
    {
        "label": "Awan Patti",
        "value": "Awan Patti"
    },
    {
        "label": "Sangota",
        "value": "Sangota"
    },
    {
        "label": "Ghora Gali",
        "value": "Ghora Gali"
    },
    {
        "label": "Mankera",
        "value": "Mankera"
    },
    {
        "label": "Shergarh",
        "value": "Shergarh"
    },
    {
        "label": "Sultanpur Mor",
        "value": "Sultanpur Mor"
    },
    {
        "label": "Nurkot",
        "value": "Nurkot"
    },
    {
        "label": "Saidpur",
        "value": "Saidpur"
    },
    {
        "label": "Hattian Bala",
        "value": "Hattian Bala"
    },
    {
        "label": "Firoza",
        "value": "Firoza"
    },
    {
        "label": "Gakuch",
        "value": "Gakuch"
    },
    {
        "label": "Haider Khel",
        "value": "Haider Khel"
    },
    {
        "label": "Surmon Chogga Grong",
        "value": "Surmon Chogga Grong"
    },
    {
        "label": "Basla",
        "value": "Basla"
    },
    {
        "label": "Bunji",
        "value": "Bunji"
    },
    {
        "label": "Ghota Fatehgarh",
        "value": "Ghota Fatehgarh"
    },
    {
        "label": "Jandola",
        "value": "Jandola"
    },
    {
        "label": "Gilgit",
        "value": "Gilgit"
    },
    {
        "label": "Drazinda",
        "value": "Drazinda"
    },
    {
        "label": "Chak Thathi",
        "value": "Chak Thathi"
    }
]